/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import MenuProvider from 'react-flexible-sliding-menu';
import Loading from '../../../../components/Loading';
import DrawerMenu from '../../../../components/DrawerMenu';
import PageNotFound from '../../../../components/PageNotFound';
import PageLayout from '../../../shared/PageLayout';
import { RSVPContext } from '../../context';
import {
  ContentWrapper,
  LPText,
  LPTitle,
} from '../../../styles';
import { Title } from '../../styles';
import EventItem from './eventItem';
import { LinkItem } from '../styles';

const RSVPPageContent = ({ url }) => {
  const {
    contextData: {
      getEvents,
      eventsListLoading,
      eventsListError,
      eventsListData,
    },
  } = useContext(RSVPContext);

  useEffect(() => {
    getEvents();
  }, []);

  if (eventsListLoading) {
    return (
      <PageLayout isDark>
        <ContentWrapper>
          <Loading />
        </ContentWrapper>
      </PageLayout>
    );
  }

  if (eventsListError) {
    return (
      <PageLayout isDark>
        <ContentWrapper>
          <LPTitle> Oops! something went wrong: </LPTitle>
          <LPText>{eventsListError.message}</LPText>
        </ContentWrapper>
      </PageLayout>
    );
  }

  const RSVPPageData = eventsListData;

  if (!RSVPPageData || _.isNull(RSVPPageData)) {
    return (
      <PageLayout isDark>
        <PageNotFound />
      </PageLayout>
    );
  }

  const {
    getVpn: {
      availableEvents,
      friendlyName,
      account: {
        coverMedia,
        snapflowTitle,
        description,
        isVerified,
        avatarMedia: {
          uri: avatarUrl,
        },
      },
    },
  } = RSVPPageData;
  const splitName = snapflowTitle.split(' ');
  const account = {
    avatarImg: avatarUrl,
    firstName: splitName[0],
    lastName: splitName[1],
    description,
    isVerified,
    extraText: `TEXT ME: ${friendlyName}`,
  };

  return (
    <MenuProvider MenuComponent={DrawerMenu}>
      <PageLayout coverMedia={coverMedia} isDark showUserInfo account={account}>
        <ContentWrapper>
          {availableEvents && availableEvents.length === 0 && (
            <LPText padded w800>
              No tickets &amp; events available. Check back soon.
            </LPText>
          )}
          {availableEvents.map((event) => (
            <LinkItem key={event.id} to={`${url}/${event.id}`}>
              <EventItem event={event} />
            </LinkItem>
          ))}
        </ContentWrapper>
      </PageLayout>
    </MenuProvider>
  );
};

RSVPPageContent.propTypes = {
  url: PropTypes.string.isRequired,
};

export default RSVPPageContent;
